const LettersPageLoggedOutView = () => {
    return (
        <p> Please login to see your notes </p>
    );
}

export default LettersPageLoggedOutView;